import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

// 🔹 Obtener documentos de una fábrica
export const getDocumentosByFabrica = async (id_Fabrica) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(
      `${API_URL}/api/documentosFabricas/${id_Fabrica}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error en getDocumentosByFabrica:", error);
    return [];
  }
};

// 🔹 Subir un documento para una fábrica
export const uploadDocumentoFabrica = async (
  file,
  id_Fabrica,
  tipoDocumento,
  fechaCaducidad
) => {
  const token = localStorage.getItem("token");
  if (!file || !id_Fabrica || !tipoDocumento || !fechaCaducidad) {
    throw new Error("Todos los campos son obligatorios.");
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("id_Fabrica", id_Fabrica);
  formData.append("TipoDocumento", tipoDocumento);
  formData.append("FechaCaducidad", fechaCaducidad);

  try {
    const response = await axios.post(
      `${API_URL}/api/documentosFabricas/upload`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error en uploadDocumentoFabrica:", error);
    throw error;
  }
};

// 🔹 Subir varios documentos para una fábrica
export const uploadDocumentosFabricaMultiples = async (
  files,
  id_Fabrica,
  tipoDocumento,
  fechaCaducidad
) => {
  const token = localStorage.getItem("token");
  const list = Array.from(files || []).filter(Boolean);
  if (list.length === 0 || !id_Fabrica || !tipoDocumento || !fechaCaducidad) {
    throw new Error("Todos los campos son obligatorios.");
  }

  const formData = new FormData();
  list.forEach((file) => formData.append("files", file));
  formData.append("id_Fabrica", id_Fabrica);
  formData.append("TipoDocumento", tipoDocumento);
  formData.append("FechaCaducidad", fechaCaducidad);

  try {
    const response = await axios.post(
      `${API_URL}/api/documentosFabricas/upload-multiple`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error en uploadDocumentosFabricaMultiples:", error);
    throw error;
  }
};

// 🔹 Eliminar un documento
export const deleteDocumentoFabrica = async (id_Documento) => {
  const token = localStorage.getItem("token");
  try {
    await axios.delete(`${API_URL}/api/documentosFabricas/${id_Documento}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("❌ Error en deleteDocumentoFabrica:", error);
    throw error;
  }
};
